import React, { useState } from 'react';
import { Box, Heading, HStack, Icon } from '@hover/blueprint';
import { iPlus } from '@hover/icons';
import anime from 'animejs';
import PremiumFeatures from './PremiumFeatures';

const PremiumFeaturesMobile: React.FC = () => {
  const [isVisible, setVisible] = useState<boolean>(false);

  const toggleVisible = () => {
    setVisible(!isVisible);
    if (!isVisible) {
      anime({
        duration: 200,
        targets: '#pricing-premium-features-mobile',
        maxHeight: [0, 500],
        easing: 'linear',
      });
    } else {
      anime({
        duration: 200,
        targets: '#pricing-premium-features-mobile',
        maxHeight: [500, 0],
        easing: 'linear',
      });
    }
  };

  return (
    <Box bg="primary.600" d={{ base: 'flex', tablet: 'none' }} flexDir="column">
      <HStack
        alignItems="center"
        onClick={toggleVisible}
        spacing={400}
        mb={400}
        mx="auto"
        mt="20px"
      >
        <Icon
          transform="auto"
          rotate={isVisible ? '45deg' : 0}
          transition="all 0.1s ease-in"
          m={0}
          icon={iPlus}
          size="default"
          strokeWidth="2px"
          color="neutral.0"
        />
        <Heading size={200} color="neutral.0">
          {isVisible ? 'Hide' : 'See'} Features
        </Heading>
      </HStack>
      <Box
        id="pricing-premium-features-mobile"
        bg="neutral.0"
        overflow="hidden"
        maxH={0}
        flexDir="column"
        px={400}
      >
        <PremiumFeatures />
      </Box>
    </Box>
  );
};

export default PremiumFeaturesMobile;
